import { Injectable } from '@angular/core';
import { HttpAuthService } from '@shared/service/http-auth.service';
import { AppConfigEnvironmentService } from '@shared/service/appconfig-environment.service';
import { AppConfigEnvironment } from '@shared/models/appconfig-environment.model';
import { Observable } from 'rxjs';
import { ExceptionGenerationPo } from '@cc-ald-operator/models/exception-generation-po.model';
import { BaseCostPo, BaseCostPoRequestBody, EBaseCostPoField } from '@cc-ald-operator/models/base-cost-po.model';
import { Utilities as U } from '@shared/utilities/utilities.model';

@Injectable({
	providedIn: 'root'
})
export class CostDetailPoService {
	environment: AppConfigEnvironment;

	constructor(
		private httpAuthService: HttpAuthService,
		private appConfig: AppConfigEnvironmentService
	) {
		this.environment = this.appConfig.Environment;
	}
  
	getBaseCostPoList(filter?: BaseCostPoRequestBody): Observable<BaseCostPo[]> {

		let url: string = this.environment.NEMO_CONTRACT_CLOSING_API + '/cost_detail_po';
		if (filter) {
			url = url + U.getQuery(filter);
		}

		return new Observable<BaseCostPo[]>(
			observer => {

				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
					res => {
						const content = res.json();
						if (res.status === 200) {
							try {
								observer.next(content.map(x => new BaseCostPo(x)));
							} catch (err) {
								console.error(err);
								observer.error(err);
							}
						} else if ([404, 405, 500].includes(res.status)) {
							console.error(content);
							observer.next(content);
						} else {
							observer.next(null);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
	}
  
  // In questo caso è possibile solo effettuare modifiche. gli unici campi che possono essere modificati (validazione FE) sono "home_closing" , "base_cost", "additional_km_cost, "km_from" , "km_to".
  createBaseCostPo(item: BaseCostPo): Observable<BaseCostPo> {

    // Filtrare soltanto i campi permessi
    const body: BaseCostPoRequestBody = ((obj) => {
      const allowedFields: EBaseCostPoField[] = [
        EBaseCostPoField.BASE_COST,
        EBaseCostPoField.ADDITIONAL_KM_COST,
        EBaseCostPoField.KM_FROM,
        EBaseCostPoField.KM_TO,
      ];
			let po = {};
      allowedFields.forEach(x => po[x] = obj[x]);
			return new BaseCostPoRequestBody(po);
    })(item);
    
		const url: string = this.environment.NEMO_CONTRACT_CLOSING_API + '/cost_detail_po/create';
		return new Observable<BaseCostPo>(
			observer => {
				this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT).subscribe(
					res => {
						const content = res.json();
						if (res.status === 200) {
							try {
								observer.next(new BaseCostPo(content));
							} catch (err) {
								console.error(err);
								observer.error(err);
							}
						} else if ([404, 405, 500].includes(res.status)) {
							console.error(content);
							observer.next(content);
						} else {
							observer.next(null);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
  }
  
  // In questo caso è possibile solo effettuare modifiche. gli unici campi che possono essere modificati (validazione FE) sono "home_closing" , "base_cost", "additional_km_cost, "km_from" , "km_to".
  updateBaseCostPo(item: BaseCostPo): Observable<BaseCostPo> {

		// adattamento al BE
		// può accettare più oggetti da modificare
		
    // Filtrare soltanto i campi permessi
    let body: BaseCostPoRequestBody[] = ((obj) => {
      const allowedFields: EBaseCostPoField[] = [
        EBaseCostPoField.BASE_COST,
        EBaseCostPoField.ADDITIONAL_KM_COST,
        EBaseCostPoField.KM_FROM,
        EBaseCostPoField.KM_TO,
        EBaseCostPoField.ID,
      ];
			let po = {};
      allowedFields.forEach(x => po[x] = obj[x]);
			return [new BaseCostPoRequestBody(po)];
    })(item);
    
		const url: string = this.environment.NEMO_CONTRACT_CLOSING_API + '/cost_detail_po/update';
		return new Observable<BaseCostPo>(
			observer => {
				this.httpAuthService.put(url, body, this.environment.ROOT_REDIRECT).subscribe(
					res => {
						const content = res.json();
						if (res.status === 200) {
							try {
								observer.next(new BaseCostPo(content));
							} catch (err) {
								console.error(err);
								observer.error(err);
							}
						} else if ([404, 405, 500].includes(res.status)) {
							console.error(content);
							observer.next(content);
						} else {
							observer.next(null);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
  }

	deleteBaseCostPo(body: BaseCostPo): Observable<ExceptionGenerationPo> {
		const url: string = this.environment.NEMO_CONTRACT_CLOSING_API + '/cost_detail_po/' + body.id;
		return new Observable<ExceptionGenerationPo>(
			observer => {
				this.httpAuthService.delete(url, this.environment.ROOT_REDIRECT).subscribe(
					res => {
						const content = res.json();
						if (res.status === 200) {
							try {
								observer.next(new ExceptionGenerationPo(content));
							} catch (err) {
								console.error(err);
								observer.error(err);
							}
						} else if ([404, 405, 500].includes(res.status)) {
							console.error(content);
							observer.next(content);
						} else {
							observer.next(null);
						}
					},
					err => {
						console.error(err);
						observer.error(err);
					}
				);
			});
  }
}
